import { useModuleGate } from '../lib/moduleGate';

/**
 * True when the decision-latency report is on: /prioritization/decision-latency
 * renders the per-stage decomposition of decision time over timestamps the
 * record already carries. Canonical gate (§2.7): `decision_latency` workspace
 * module + flag. Read-only surface — nothing is gated server-side because
 * nothing is written.
 */
export function useDecisionLatencyEnabled(): boolean {
  return useModuleGate('decision_latency');
}
